import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './tabs.module.scss';

export type TabsProps = {
  items: {
    headline: string;
    content: JSX.Element;
    id: string;
    disabled?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  }[];
  initialTab?: number;
  size?: '200' | '300';
  stretchButtons?: boolean;
  className?: string;
};

export const Tabs: React.FC<TabsProps> = ({ items, className, initialTab, size = '200', stretchButtons = false }) => {
  const [isActive, setIsActive] = useState(initialTab || 0);

  return (
    <div className={classnames(styles.tabs, className, styles[`s${size}`])} data-testid="tabs-component">
      <div role="tablist" className={classnames(styles.tablist, { [styles.stretch]: stretchButtons })}>
        {items.map((item, i) => {
          const buttonClass = classnames(styles.button, {
            [styles.active]: i === isActive
          });

          return (
            <button
              key={`${item.headline}-${i}-control`}
              id={`${item.id}-control`}
              aria-controls={`${item.id}-panel`}
              aria-selected={i === isActive}
              className={buttonClass}
              role="tab"
              onClick={(e) => {
                setIsActive(i);
                item.onClick && item.onClick(e);
              }}
              disabled={item.disabled}
            >
              {item.headline}
            </button>
          );
        })}
      </div>
      {items.map((item, i) => {
        const panelClass = classnames(styles.panel, {
          [styles.active]: i === isActive
        });

        return (
          <div
            aria-hidden={i !== isActive}
            key={`${item.headline}-${i}-panel`}
            id={`${item.id}-panel`}
            role="tabpanel"
            aria-labelledby={`${item.id}-control`}
            className={panelClass}
          >
            {item.content}
          </div>
        );
      })}
    </div>
  );
};
